export enum ROUTES {
	HOME = '/',
	FAQ = '/faq',
	PROMOTIONS = '/all-promotions',
	PROMOTION = '/promotion',
	PROMOTION_COMPLETED = '/completed-promotion/:id',
	SHOP = '/shop',
	QUESTS = '/quests',
	SUPPORT = '/support',
	TOURNAMENTS = '/tournaments',
	CYBERMARATHON = '/cybermarathon',
	SKINPLACE = '/skinplace',
	PROFILE = '/profile',
	WELCOME = '/welcome',
	TOURNAMENT = '/tournament/:id',
	INFO = '/info',
	COIN_RACE = '/coin-race',
	COIN_RACE_DETAILS = '/coin-race/:id'
}
